import { gtmPush } from "."

export const gtmAddToWishlist = (products: { id: string; name: string; price: number | `${number}` }[]) => {
    gtmPush({ event: "addToWishlist", ecommerce: { wishlist: { add: { products } } } })
}

export const gtmRemoveFromWishlist = (products: { id: string; name: string; price: number | `${number}` }[]) => {
    gtmPush({ event: "removeFromWishlist", ecommerce: { wishlist: { remove: { products } } } })
}

export const gtmWishlistView = (products: { id: string; name: string; price: number | `${number}` }[]) => {
    gtmPush({ event: "wishlistView", ecommerce: { wishlist: { view: { products } } } })
}

export const gtmAddToCartFromWishlist = (products: { id: string; name: string; price: number | `${number}` }[]) => {
    gtmPush({ event: "addToCartFromWishlist", ecommerce: { wishlist: { addToCart: { products } } } })
}
